import React from 'react';
import { Link } from 'react-router-dom';

// Marker a page stores as its load error when the request got no answer at
// all (no connection), so it can show this notice instead of "Failed to load".
export const OFFLINE = 'offline';

// A request with no response means no connection; anything else is a real
// server error and keeps the page's own message.
export const loadError = (err, message) => (err && !err.response ? OFFLINE : message);

// The pages that read the on-phone copy and so keep working with no signal.
const OFFLINE_PAGES = [
  { to: '/sell',         label: 'Record a sale' },
  { to: '/inventory',    label: 'Inventory' },
  { to: '/customers',    label: 'Customers' },
  { to: '/debtors',      label: 'Debtors' },
  { to: '/transactions', label: 'Transactions' },
];

export default function OfflineNotice({ message, showLinks = true }) {
  return (
    <div role="status" style={{
      background: '#1e293b', border: '1px solid #475569', borderRadius: '14px',
      padding: '0.9rem 1.1rem', marginBottom: '1rem', color: '#cbd5e1', fontSize: '0.85rem',
    }}>
      <div style={{ fontWeight: 700, color: '#e2e8f0', marginBottom: '0.2rem' }}>You're offline</div>
      {message || 'This page needs a connection and will load when you\'re back online.'}{' '}
      You can still sell, record stock, customers and expenses — they're saved on this phone and sent automatically.
      {showLinks && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginTop: '0.75rem' }}>
          {OFFLINE_PAGES.map(p => (
            <Link key={p.to} to={p.to} className="btn-ghost" style={{
              padding: '0.4rem 0.75rem', fontSize: '0.8rem', borderRadius: '8px', textDecoration: 'none',
            }}>
              {p.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

// Drop-in for the pages' "Failed to load …" line.
export function PageError({ error }) {
  if (error === OFFLINE) return <OfflineNotice />;
  return <p style={{ color: 'var(--color-danger)' }}>{error}</p>;
}
